import { cn } from '@/lib/utils';

interface AttemptBadgeProps {
  attempt?: number;
  className?: string;
}

export function AttemptBadge({ attempt = 1, className }: AttemptBadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full bg-gray-100 px-2 py-0.5 text-xs font-medium text-gray-800',
        className
      )}
    >
      {`Attempt ${attempt}`}
    </span>
  );
} 